<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a Contact</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form ref="form" class="modal-card-body" :valid.sync="valid">
          <div class="field">
            <label class="label">First Name*</label>
            <v-text-field 
              required
              placeholder="Enter First Name"
              v-model="contact.first_name">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Last Name*</label>
            <v-text-field 
              required
              placeholder="Enter Last Name"
              v-model="contact.last_name">
            </v-text-field>
          </div>
          <div class="field" v-if="!companyId">
            <label class="label">Company*</label>
            <v-select
              required
              v-if="companies.length > 0"
              :options="companies"
              item-text="name"
              item-value="id"
              v-model="contact.company_id"
            />
          </div>
          <div class="field">
            <label class="label">Position</label>
            <v-text-field 
              placeholder="Enter Contact Position"
              v-model="contact.position">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Phone Number*</label>
            <v-text-field 
              required
              placeholder="Enter Contact Phone Number"
              v-model="contact.phone1">
            </v-text-field>
          </div>
          <div class="field">
            <label class="label">Email*</label>
            <v-text-field 
              required
              placeholder="Enter Contact Email"
              :rules="emailRules"
              v-model="contact.email">
            </v-text-field>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNewContact()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapState, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    companyId: {
      type: [String, Number]
    }
  },
  components: { VTextField, VForm, VSelect },
  data() {
    return {
      contact: {
        first_name: '',
        last_name: '',
        company_id: '',
        position: '',
        phone1: '',
        email: ''
      },
      valid: false,
      emailRules: [
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(v) || 'Invalid e-mail'
        }
      ]
    }
  },
  computed: {
    ...mapState("tickets", ["companies"])
  },
  created() {
    if (this.companyId) {
      this.contact.company_id = this.companyId;
    }

    if (this.companies.length == 0) {
      this.getCompanies({ per_page: 1000 });
    }
  },
  methods: {
    ...mapActions("tickets", ["addContact", "getCompanies"]),
    addNewContact() {
      this.addContact(this.contact).then(resp => {
        this.$emit('success', resp.data);
        this.close(true);
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>
